import { render } from "./AppGalleryItem.vue?vue&type=template&id=2789c8ee&scoped=true"
import script from "./AppGalleryItem.vue?vue&type=script&lang=js"
export * from "./AppGalleryItem.vue?vue&type=script&lang=js"

import "./AppGalleryItem.vue?vue&type=style&index=0&id=2789c8ee&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789c8ee"]])

export default __exports__